import { render, staticRenderFns } from "./TabletVersionOfSidebar.vue?vue&type=template&id=3c9109de&scoped=true&"
import script from "./TabletVersionOfSidebar.vue?vue&type=script&lang=js&"
export * from "./TabletVersionOfSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TabletVersionOfSidebar.vue?vue&type=style&index=0&id=3c9109de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9109de",
  null
  
)

export default component.exports